import React from 'react';
import '../../css/items.css';

import ListTable from './ListTable';

import columns from '../../json/itemColumns.json'
import rows from '../../json/items.json';


function Items(props){
  return (
    <div className="items">
      <ListTable
        columns={columns}
        rows={rows}
        stateName={props.stateName}
        state={props.state}
        updateState={props.updateState}
      />
    </div>
  );
}

export default Items;
